const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

function isNonEmpty(s) {
  return typeof s === 'string' && s.trim().length > 0
}

function validPhone(s) {
  if (!isNonEmpty(s)) return false
  const digits = String(s).replace(/\D/g, '')
  return digits.length >= 6
}

function validateBoolean(val) {
  if (val !== true && val !== false) {
    return { valid: false, messageKey: 'validation.selectYesNo' }
  }
  return { valid: true }
}

/**
 * Validates the current wizard step before leaving it (Next / Submit / Enter).
 * @param {number} step — currentStep (1–8 for form steps)
 * @param {object} formData
 * @returns {{ valid: boolean, messageKey?: string }}
 */
export function validateStep(step, formData) {
  switch (step) {
    case 1: {
      const { firstName, lastName, phone, email, company, position } = formData
      const fields = [firstName, lastName, phone, email, company, position]
      if (!fields.every(v => isNonEmpty(v == null ? '' : String(v)))) {
        return { valid: false, messageKey: 'validation.fillPersonal' }
      }
      if (!EMAIL_RE.test(String(email).trim())) {
        return { valid: false, messageKey: 'validation.invalidEmail' }
      }
      if (!validPhone(phone)) {
        return { valid: false, messageKey: 'validation.invalidPhone' }
      }
      return { valid: true }
    }
    case 2: {
      const n = formData.hotelCount
      if (typeof n !== 'number' || !Number.isFinite(n) || n < 1) {
        return { valid: false, messageKey: 'validation.minOne' }
      }
      return { valid: true }
    }
    case 3: {
      const { hotels, hotelCount } = formData
      if (!Array.isArray(hotels) || hotels.length !== hotelCount || hotelCount < 1) {
        return { valid: false, messageKey: 'validation.fillHotelFields' }
      }
      for (let i = 0; i < hotels.length; i++) {
        const h = hotels[i]
        if (!h) return { valid: false, messageKey: 'validation.fillHotelFields' }
        if (
          !isNonEmpty(h.street) ||
          !isNonEmpty(h.houseNumber) ||
          !isNonEmpty(h.zip) ||
          !isNonEmpty(h.city) ||
          !isNonEmpty(h.description)
        ) {
          return { valid: false, messageKey: 'validation.fillHotelFields' }
        }
        const u = Number(h.units)
        if (!Number.isFinite(u) || u < 1) {
          return { valid: false, messageKey: 'validation.fillHotelFields' }
        }
      }
      return { valid: true }
    }
    case 4: {
      const cm = formData.channelManager
      if (cm == null || String(cm).trim() === '') {
        return { valid: false, messageKey: 'validation.selectChannelManager' }
      }
      return { valid: true }
    }
    case 5:
      return validateBoolean(formData.hasReception)
    case 6:
      return validateBoolean(formData.hasStripe)
    case 7:
      return validateBoolean(formData.hasPhoneSystem)
    case 8:
      return validateBoolean(formData.wantsKiosk)
    case 9: {
      // a slot must be picked, or the step explicitly skipped ('SKIP' —
      // also auto-set when the slot service is unavailable)
      if (!isNonEmpty(formData.meetingSlot)) {
        return { valid: false, messageKey: 'validation.selectSlot' }
      }
      return { valid: true }
    }
    default:
      return { valid: true }
  }
}
